import { fmtN } from "@/components/overview/Momentum";

// ₹ compact: Cr / L / K; RO counts use plain numbers
export const fmtL = (v) => {
  if (v == null) return "—";
  const a = Math.abs(v);
  if (a >= 1e7) return `${(v / 1e7).toFixed(2)} Cr`;
  if (a >= 1e5) return `${(v / 1e5).toFixed(1)} L`;
  if (a >= 1e3) return `${(v / 1e3).toFixed(1)} K`;
  return Math.round(v).toLocaleString("en-IN");
};
export const fmtRs = (v) => (v == null ? "—" : `₹${fmtL(v)}`);
export const fmtBay = (v) => (v == null ? "—" : Number(v).toFixed(2));
export const REV_KEYS = ["total_gs", "labour", "parts", "ccs", "accs", "warranty", "body_shop"];
export const isRo = (k) => !REV_KEYS.includes(k);
export const fmtFor = (k) => (isRo(k) ? (v) => fmtN(v) : fmtL);
// metric groups of the workshop table — Total GS last so it can be frozen on the right
export const METRIC_GROUPS = [["labour", "Labour"], ["parts", "Parts"], ["ccs", "CCS"], ["accs", "Accs"], ["body_shop", "Body Shop"], ["gs_ros", "GS ROs"], ["ar", "AR ROs"], ["total_gs", "Total GS"]];
export const tdLabel = (period) => (period?.kind === "week" ? "WTD target" : "MTD target");
export const planLabel = (period) => (period?.kind === "week" ? "week target" : "target");
